<a
  class="qaroni-link"
  tabindex="0"
  (click)="goToBack()"
  (keypress)="goToBack()">
  <div class="inline-flex max-w-full flex-row items-center">
    <mat-icon class="me-1">arrow_back</mat-icon
    ><span class="truncate">{{ text() }}</span>
  </div>
</a>
